import FiltersSidebar from "./FiltersSidebar";
import PersonArtFilters from "../pages/person/filters/PersonArtFilters";
import PersonFirmaFilter from "../pages/person/filters/PersonFirmaFilter";
import PersonTypeFilters from "../pages/person/filters/PersonTypeFilters";
import PersonInteresseFilter from "../pages/person/filters/PersonInteresseFilters";
import PersonForeningFilter from "../pages/person/filters/PersonForeningFilters";
import PersonUdvalgFilter from "../pages/person/filters/PersonUdvalgFilters";
import { useContext } from "react";
import {
  PersonFiltersContext,
  PersonFiltersEventContext,
} from "../../context/FiltersContext";
import { PersonCustomFilterConfig } from "../../config/filter/CustomFilterConfig";
import CustomFilter from "./custom/CustomFilter";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../ErrorFallback";
import PersonKundenummerFilter from "../pages/person/filters/PersonKundenummerFilter";
import PersonStatusFilter from "../pages/person/filters/PersonStatusFilter";
import PersonBeskikkelseFilter from "../pages/person/filters/PersonBeskikkelseFilter";
import PersonGeografiFilter from "../pages/person/filters/PersonGeografiFilter";
import PersonEfteruddannelsesFilter from "../pages/person/filters/PersonEfteruddannelsesFilter";
import PersonPaabudFilter from "../pages/person/filters/PersonPaabudFilter";
import PersonPaalaegFilter from "../pages/person/filters/PersonPaalaegFilter";
import PersonKursusFilter from "../pages/person/filters/PersonKursusFilter";
import PersonTilsynFilter from "../pages/person/filters/PersonTilsynFilter";

export default function FiltersPerson() {
  const updateFilters = useContext(PersonFiltersEventContext);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => updateFilters({ event: "reset" })}
    >
      <FiltersSidebar
        contextType="Person"
        queryFilterEventContext={PersonFiltersEventContext}
        onReset={() => {
          updateFilters({
            event: "reset",
          });
        }}
      >
        <PersonStatusFilter />
        <PersonArtFilters />
        <PersonBeskikkelseFilter />
        <PersonFirmaFilter />
        <PersonTypeFilters />
        <PersonForeningFilter />
        <PersonUdvalgFilter />
        <PersonInteresseFilter />
        <PersonKundenummerFilter />
        <PersonGeografiFilter />
        <PersonKursusFilter />
        <PersonEfteruddannelsesFilter />
        <PersonPaabudFilter />
        <PersonPaalaegFilter />
        <PersonTilsynFilter />

        <CustomFilter
          filterConfig={PersonCustomFilterConfig}
          queryFilterContext={PersonFiltersContext}
          queryFilterEventContext={PersonFiltersEventContext}
        />
      </FiltersSidebar>
    </ErrorBoundary>
  );
}
